import { Product, CasePricingInfo } from '../types';
import { getCasePricingInfo } from './caseQuantity';

export const getDeposit = (lost_amount: number = 0) => lost_amount;
export const getServiceFee = (service_price: number = 0) => service_price;

export const getUnitPrice = (lost_amount: number = 0, service_price: number = 0) => {
  return getDeposit(lost_amount) + getServiceFee(service_price);
};

export const formatMoney = (amount: number | undefined | null) => `$${((amount ?? 0) / 100).toFixed(2)}`;

/**
 * Get the price for a specific case quantity
 */
export const getCasePrice = (product: Product, caseQuantity: number): number => {
  const casePricing = getCasePricingInfo(product, caseQuantity);
  return casePricing ? casePricing.total_price_cents : 0;
};

/**
 * Get the unit price from the product's pricing info (more accurate than calculating manually)
 */
export const getProductUnitPrice = (product: Product): number => {
  return product.service_price; // Only use service_price for unit price display
};

/**
 * Format pricing display for a case (e.g., "$52.00 (50 × $1.00 + $2.00 packing)")
 */
export const formatCasePriceBreakdown = (product: Product, caseQuantity: number): string => {
  const casePricing = getCasePricingInfo(product, caseQuantity);
  if (!casePricing) {
    return formatMoney(0);
  }

  const totalPrice = formatMoney(casePricing.total_price_cents);
  const unitPrice = formatMoney(casePricing.unit_price_cents);
  const packingCost = formatMoney(casePricing.packing_cost_cents);
  
  // Single quantity items just show the price
  if (caseQuantity === 1) {
    return totalPrice;
  }
  
  // Multi-quantity cases show breakdown with packing cost
  return `${totalPrice} (${caseQuantity} × ${unitPrice} + ${packingCost} packing)`;
}; 